(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/extends', 'babel-runtime/helpers/classCallCheck', 'babel-runtime/helpers/possibleConstructorReturn', 'babel-runtime/helpers/inherits', 'react', 'prop-types', 'animejs', './levels', './Notification.css', './NotificationBoxVariant'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/extends'), require('babel-runtime/helpers/classCallCheck'), require('babel-runtime/helpers/possibleConstructorReturn'), require('babel-runtime/helpers/inherits'), require('react'), require('prop-types'), require('animejs'), require('./levels'), require('./Notification.css'), require('./NotificationBoxVariant'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.classCallCheck, global.possibleConstructorReturn, global.inherits, global.react, global.propTypes, global.animejs, global.levels, global.Notification, global.NotificationBoxVariant);
    global.Notification = mod.exports;
  }
})(this, function (exports, _extends2, _classCallCheck2, _possibleConstructorReturn2, _inherits2, _react, _propTypes, _animejs, _levels, _Notification, _NotificationBoxVariant) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Notification = undefined;

  var _extends3 = _interopRequireDefault(_extends2);

  var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

  var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

  var _inherits3 = _interopRequireDefault(_inherits2);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _animejs2 = _interopRequireDefault(_animejs);

  var _levels2 = _interopRequireDefault(_levels);

  var _NotificationBoxVariant2 = _interopRequireDefault(_NotificationBoxVariant);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Notification = exports.Notification = function (_React$Component) {
    (0, _inherits3.default)(Notification, _React$Component);

    function Notification(props) {
      (0, _classCallCheck3.default)(this, Notification);

      var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));

      _this.onClose = function () {
        var elementId = _this.state.elementId;

        _animejs2.default.timeline().add((0, _extends3.default)({
          targets: elementId,
          opacity: _this.props.inline ? 1 : 0,
          easing: _this.props.inline ? 'linear' : 'easeOutExpo'
        }, _Notification.animateOut1)).add((0, _extends3.default)({ targets: elementId }, _Notification.animateOut2)).finished.then(_this.onCloseAnimationFinish);
      };

      _this.onCloseAnimationFinish = function () {
        // const el = document.querySelector(selector);
        _this.setState({ visible: false });
        // if (el) el.style.display = 'none';

        if (_this.props.dismissNotification) _this.props.dismissNotification(_this.state.id);
      };

      _this.state = {
        visible: props.message && props.level && props.id,
        elementId: '#pjp-notification-' + props.id
      };
      return _this;
    }

    Notification.prototype.componentDidMount = function componentDidMount() {
      (0, _animejs2.default)((0, _extends3.default)({ targets: this.state.elementId }, _Notification.animateIn));
      //  if timeout set to true or not set - notification will dismiss in 4seconds
      if (this.props.timeOut === false || this.props.level === _levels2.default.error || this.props.level === _levels2.default.warn || this.props.level === _levels2.default.info) {
        return;
      }

      this.timeout = window.setTimeout(this.onClose, 4000);
    };

    Notification.prototype.componentWillUnmount = function componentWillUnmount() {
      clearTimeout(this.timeout);
    };

    Notification.prototype.render = function render() {
      var _props = this.props,
          level = _props.level,
          message = _props.message,
          id = _props.id,
          isShowingIcon = _props.isShowingIcon,
          timeOut = _props.timeOut,
          messageLabel = _props.messageLabel;

      if (!this.state.visible) return _react2.default.createElement('span', null);

      var elementId = 'pjp-notification-' + id;

      return _react2.default.createElement(
        _Notification.NotificationBox,
        {
          id: elementId,
          level: level,
          isShowingIcon: isShowingIcon,
          timeOut: timeOut
        },
        _react2.default.createElement(_NotificationBoxVariant2.default, {
          level: level,
          isShowingIcon: isShowingIcon,
          message: message,
          onCloseHandler: this.onClose,
          messageLabel: messageLabel
        })
      );
    };

    return Notification;
  }(_react2.default.Component);

  Notification.defaultProps = {
    isShowingIcon: true
  };
  exports.default = Notification;


  Notification.propTypes = {
    id: _propTypes2.default.string.isRequired,
    message: _propTypes2.default.string.isRequired,
    messageLabel: _propTypes2.default.string, // override instead of Info, Warn, etc.
    onClose: _propTypes2.default.func,
    dismissNotification: _propTypes2.default.func,
    inline: _propTypes2.default.bool,
    isShowingIcon: _propTypes2.default.bool,
    timeOut: _propTypes2.default.bool
  };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Notifications/Notification.js
// module id = 1907
// module chunks = 1